// src/config/hayllis2SportRedirect.js

/**
 * PURPOSE: Eventos cuyos deportes ya no se muestran en Hayllis Legacy sino en Hayllis 2.0 (FTR-0039).
 * RESPONSIBILITIES: Lista cerrada de idevent. Al entrar al deporte de uno de estos eventos, Legacy lleva al usuario
 *   a la página de ese mismo evento y deporte en Hayllis 2.0 (origen canónico en delegatePortal.js). Cualquier otro
 *   evento sigue en Legacy exactamente igual. La página del evento y su lista de deportes nunca se redirigen: solo
 *   el deporte elegido. Excepción acotada por evento: los idsport de HAYLLIS_2_SPORT_REDIRECT_LEGACY_SPORT_IDS
 *   siguen en Legacy aunque su evento esté en la lista. Este repositorio no usa variables de entorno (config
 *   comprometida en src/config/): agregar o quitar un evento o una excepción es un cambio deliberado y un nuevo
 *   despliegue.
 * COLLABORATORS: src/utils/hayllis2SportRedirect.js, src/pages/Sport.jsx, src/config/delegatePortal.js.
 */
export const HAYLLIS_2_SPORT_REDIRECT_EVENT_IDS = Object.freeze([1001]);

// Evento 1001: Vóley Damas (16) y Vóley Varones (17) permanecen en Legacy (visor de vóley, formato de vóley).
export const HAYLLIS_2_SPORT_REDIRECT_LEGACY_SPORT_IDS = Object.freeze({
  1001: Object.freeze([16, 17]),
});
